<ea-dropdown-nav-item
	#dropdownContentNav
	[showArrow]="true"
	tooltipText="Support and Benefit Documents"
	(click)="handleSupportIconClick()"
	faIconClass="question-circle"
	[dropdownId]="constants.dropdownIds.supportServices"
>
	@if (showSupportServicesMenu) {
		<ng-template #dropdownContent>
			<ul class="support-services-menu">
				<li (keydown)="handleDropdownOnKeydown(false, false)">
					<ea-button-link
						id="supportLink"
						name="Support"
						(onClick)="navigate(constants.BASE_APP_ROUTES.support)"
						data-cy="support-link"
					>
						Support and Benefit Documents
					</ea-button-link>
				</li>
				@if (allowEdAccessSupportLink) {
					<li (keydown)="handleDropdownOnKeydown(true, false)">
						<ea-button-link
							id="edAccessSupportLink"
							name="About No Cost Bachelor's Degree Program"
							(onClick)="
								navigate(constants.BASE_APP_ROUTES.educationAccess.learnMore)
							"
							data-cy="education-access-support-link"
						>
							{{ edAccessInfoMenuItem }}
						</ea-button-link>
					</li>
				}
				@if (liveChatEnabled) {
					<li (keydown)="handleDropdownOnKeydown(false, true)">
						<ea-live-chat-button
							buttonText="Get Live Help"
							data-cy="live-chat-link"
						></ea-live-chat-button>
					</li>
				}
			</ul>
		</ng-template>
	}
</ea-dropdown-nav-item>
